/**
 * Create an organization.
 */

import { Form, redirect, useActionData, useNavigation } from 'react-router-dom'
import type { ActionFunctionArgs } from 'react-router-dom'
import { createOrganizationInput } from '@erp/contracts'
import { api, ApiError } from '../api'
import { invalid, issuesFrom, type FormResult } from '../forms'
import { OrganizationFields, readOrganizationForm } from '../components/organization-form'
import { Button, PageHeader } from '../ui'

export async function action({ request }: ActionFunctionArgs): Promise<FormResult | Response> {
  const parsed = createOrganizationInput.safeParse(readOrganizationForm(await request.formData()))
  if (!parsed.success) return invalid(issuesFrom(parsed.error))

  try {
    const organization = await api.organizations.create(parsed.data)
    return redirect(`/crm/organizations/${organization.id}`)
  } catch (error) {
    if (error instanceof ApiError) return invalid(error.issues, error.message)
    throw error
  }
}

export default function NewOrganization() {
  const result = useActionData() as FormResult | undefined
  const navigation = useNavigation()
  const saving = navigation.state === 'submitting'

  return (
    <>
      <PageHeader title="New organization" />
      {result?.message ? <div className="ax-alert ax-alert-danger">{result.message}</div> : null}

      <Form method="post" className="ax-form">
        <OrganizationFields issues={result?.issues ?? {}} />
        <div className="ax-form-actions">
          <Button variant="solid" type="submit" disabled={saving}>
            {saving ? 'Creating…' : 'Create organization'}
          </Button>
          <a className="ax-btn" href="/crm/organizations">
            Cancel
          </a>
        </div>
      </Form>
    </>
  )
}
